import SearchInput from 'components/SearchInput';
import { StyledTableActions } from './Projects.style';
import { PaginationSection } from './PaginationSection';

const TableActions = ({
  keyword,
  setKeyword,
  totalProjects,
  paginationHandler,
  dataCy = ''
}) => {
  return (
    <StyledTableActions data-cy={dataCy}>
      <SearchInput
        width='20%'
        height='3rem'
        placeholder='Search for project name'
        value={keyword}
        onChange={setKeyword}
      />
      <PaginationSection
        total={totalProjects}
        paginationHandler={paginationHandler}
      />
    </StyledTableActions>
  );
};

export default TableActions;
